import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {openLeadModal, setUseAdditionalFormField} from "../state/main_lead_slice";
import {IAmplitudeLeadFormTrackingContext} from "../types/lead/IAmplitudeLeadFormEventTracking";
import {
    ApplicationModalOpenTrackingInput,
    isApplicationModalAmplitudeOnlyOpenTracking,
    isApplicationModalOpenTrackingWithAmplitude,
    isGtmEventLeadForm
} from "../types/lead/IApplicationModalOpenTracking";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (tracking?: ApplicationModalOpenTrackingInput) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "trackingMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, ...openModalPayload} = props;
    const dispatch = useAppDispatch();

    const isOpened = useAppSelector((state) => state.mainLead.isModalOpen);
    const wasOpenedRef = useRef(false);

    const handleOpenModal = useCallback(
        (openButtonSource: string, openButtonSourceText: string, amplitudeLeadFormEventTracking: IAmplitudeLeadFormTrackingContext | null) => {
            if (openModalPayload.useAdditionalFormField) {
                dispatch(setUseAdditionalFormField(openModalPayload.useAdditionalFormField));
            }

            dispatch(
                openLeadModal({
                    ...openModalPayload,
                    trackingMeta: {
                        openButtonSource,
                        openButtonSourceText
                    },
                    amplitudeLeadFormEventTracking
                })
            );
        },
        [dispatch, openModalPayload]
    );

    const openModal = useCallback(
        (tracking?: ApplicationModalOpenTrackingInput) => {
            if (!tracking) {
                return;
            }

            if (isApplicationModalAmplitudeOnlyOpenTracking(tracking)) {
                handleOpenModal(tracking.amplitude.cta_text, tracking.amplitude.form_location, tracking.amplitude);
                return;
            }

            if (isApplicationModalOpenTrackingWithAmplitude(tracking)) {
                gtmEventFormOpen(tracking.gtm.clickText, tracking.gtm.source, tracking.gtm.vendorName, tracking.gtm.offerName);
                handleOpenModal(tracking.gtm.clickText, tracking.gtm.source, tracking.amplitude);
                return;
            }

            if (isGtmEventLeadForm(tracking)) {
                gtmEventFormOpen(tracking.clickText, tracking.source, tracking.vendorName, tracking.offerName);
                handleOpenModal(tracking.clickText, tracking.source, null);
            }
        },
        [handleOpenModal]
    );

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {openLeadModal, setUseAdditionalFormField} from "../state/main_lead_slice";
import {IAmplitudeLeadFormTrackingContext} from "../types/lead/IAmplitudeLeadFormEventTracking";
import {
    ApplicationModalOpenTrackingInput,
    isApplicationModalAmplitudeOnlyOpenTracking,
    isApplicationModalOpenTrackingWithAmplitude,
    isGtmEventLeadForm
} from "../types/lead/IApplicationModalOpenTracking";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (tracking?: ApplicationModalOpenTrackingInput) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "trackingMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, ...openModalPayload} = props;
    const dispatch = useAppDispatch();

    const isOpened = useAppSelector((state) => state.mainLead.isModalOpen);
    const wasOpenedRef = useRef(false);

    const handleOpenModal = useCallback(
        (openButtonSource: string, openButtonSourceText: string, amplitudeLeadFormEventTracking: IAmplitudeLeadFormTrackingContext | null) => {
            if (openModalPayload.useAdditionalFormField) {
                dispatch(setUseAdditionalFormField(openModalPayload.useAdditionalFormField));
            }

            dispatch(
                openLeadModal({
                    ...openModalPayload,
                    trackingMeta: {
                        openButtonSource,
                        openButtonSourceText
                    },
                    amplitudeLeadFormEventTracking
                })
            );
        },
        [dispatch, openModalPayload]
    );

    const openModal = useCallback(
        (tracking?: ApplicationModalOpenTrackingInput) => {
            if (!tracking) {
                return;
            }

            if (isApplicationModalAmplitudeOnlyOpenTracking(tracking)) {
                handleOpenModal(tracking.amplitude.cta_text, tracking.amplitude.form_location, tracking.amplitude);
                return;
            }

            if (isApplicationModalOpenTrackingWithAmplitude(tracking)) {
                gtmEventFormOpen(tracking.gtm.clickText, tracking.gtm.source, tracking.gtm.vendorName, tracking.gtm.offerName);
                handleOpenModal(tracking.gtm.clickText, tracking.gtm.source, tracking.amplitude);
                return;
            }

            if (isGtmEventLeadForm(tracking)) {
                gtmEventFormOpen(tracking.clickText, tracking.source, tracking.vendorName, tracking.offerName);
                handleOpenModal(tracking.clickText, tracking.source, null);
            }
        },
        [handleOpenModal]
    );

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
